import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-803c00a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "configurator-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "configurator-title" }, "Konfigurátor", -1))
const _hoisted_3 = { class: "configurator-content" }
const _hoisted_4 = { class: "configurator-left" }
const _hoisted_5 = { class: "configurator-text model" }
const _hoisted_6 = { class: "configurator-options" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "variant-text"
}
const _hoisted_9 = {
  key: 1,
  class: "configurator-text variant-text"
}
const _hoisted_10 = { class: "variant-code configurator-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "variants"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "variant-text" }
const _hoisted_15 = { class: "variant-code configurator-text" }
const _hoisted_16 = { class: "configurator-option" }
const _hoisted_17 = { class: "configurator-text" }
const _hoisted_18 = { class: "configurator-text-info" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "material-picker" }
const _hoisted_22 = { class: "colors" }
const _hoisted_23 = { class: "series-picker" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  style: {"display":"flex","width":"100%"}
}
const _hoisted_26 = { style: {"width":"33%","display":"flex","flex-direction":"column","align-items":"center","border-right":"solid 1px black"} }
const _hoisted_27 = { class: "configurator-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"0","width":"calc(100% - 30px)"} }, "O látce", -1))
const _hoisted_29 = { style: {"margin":"0","padding":"15px"} }
const _hoisted_30 = { style: {"width":"67%","padding-left":"20px"} }
const _hoisted_31 = { style: {"display":"flex","flex-direction":"column","align-items":"flex-start","width":"calc(6*70px)"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"0"} }, " O sérii ", -1))
const _hoisted_33 = { style: {"margin":"0"} }
const _hoisted_34 = { class: "series" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"70px","color":"black"} }, " + 0,- ", -1))
const _hoisted_37 = {
  key: 1,
  class: "configurator-option-extended"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "configurator-text model" }, "Příslušenství", -1))
const _hoisted_39 = { class: "material-box" }
const _hoisted_40 = { class: "colors" }
const _hoisted_41 = { class: "series-picker" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "accessories" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "configurator-right" }
const _hoisted_48 = { class: "three" }
const _hoisted_49 = { ref: "three" }
const _hoisted_50 = { class: "three-controls" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.chairData.name), 1),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.chairData.variants)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["variant variant-select pointer", {'variant-selected': _ctx.variantSelect}]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.variantSelect = !_ctx.variantSelect))
                }, [
                  (!_ctx.variantSelect)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.chosenVariant.text), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, "Vyberte verzi židle")),
                  _createElementVNode("div", _hoisted_10, [
                    (!_ctx.variantSelect)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.chosenVariant.code), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.variantSelect)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "icon",
                          icon: ['fas', 'chevron-down']
                        }))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 2,
                          class: "icon",
                          icon: ['fas', 'chevron-up']
                        }))
                  ])
                ], 2),
                (_ctx.variantSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.variants, (variant) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["variant select pointer", {'selected': _ctx.chosenVariant === variant}]),
                          key: variant.id,
                          onClick: ($event: any) => (_ctx.applyVariant(variant))
                        }, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(variant.text), 1),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(variant.code), 1)
                        ], 10, _hoisted_13))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.config, (part) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "configurator-option-extended",
              key: part.id
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_17, "Zvolte " + _toDisplayString(part.text), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(part.colorName), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (part.settings = !part.settings),
                    class: "material-picker-button",
                    style: _normalizeStyle({background: `url(../materials/${part.color})`, 'background-repeat': 'no-repeat', 'background-size': 'cover'})
                  }, _toDisplayString(part.colorName.split(" ")[1]), 13, _hoisted_19)
                ])
              ]),
              (part.settings)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal",
                    onClick: ($event: any) => (part.settings = false)
                  }, [
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      class: "material-box"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.colors, (series) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: series,
                                class: _normalizeClass(["series-name pointer", {'chosen': _ctx.chosenSeries === series.name}]),
                                onClick: ($event: any) => {_ctx.chosenSeries = series.name; _ctx.changeLipsum('serie')},
                                style: {"border-bottom":"solid 1px black"}
                              }, _toDisplayString(series.name), 11, _hoisted_24))
                            }), 128))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.colors, (series) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: series.name,
                              style: {"display":"flex","align-items":"center","justify-content":"center"}
                            }, [
                              (_ctx.chosenSeries === series.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{"margin":"20px 0","width":"100px","height":"100px"}, {background: `url(../materials/${part.color})`, 'background-repeat': 'no-repeat', 'background-size': 'cover'}])
                                      }, null, 4),
                                      _createElementVNode("h2", _hoisted_27, _toDisplayString(part.colorName), 1),
                                      _hoisted_28,
                                      _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.lipsum), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.lipsumSerie), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_34, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(series.values, (color) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: color.file,
                                            class: "material-picker-button color",
                                            style: _normalizeStyle([{background: `url(../materials/${color.file})`, 'background-repeat': 'no-repeat', 'background-size': 'cover'}, {"position":"relative","margin-bottom":"40px"}]),
                                            onClick: ($event: any) => {_ctx.applyColor(part, color); _ctx.changeLipsum('material')}
                                          }, [
                                            _createTextVNode(_toDisplayString(color.name.split(" ")[1]) + " ", 1),
                                            _hoisted_36
                                          ], 12, _hoisted_35))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 8, _hoisted_20))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.chairData.accessories)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    class: "material-picker"
                  }, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.accessories, (accessories) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: accessories.id,
                            class: _normalizeClass(["series-name pointer", {'chosen': _ctx.chosenAccessories === accessories}]),
                            onClick: ($event: any) => (_ctx.chosenAccessories = accessories)
                          }, _toDisplayString(accessories.text), 11, _hoisted_42))
                        }), 128))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairData.accessories, (accessories) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: accessories.text
                        }, [
                          (_ctx.chosenAccessories === accessories)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  (accessories.id !== 'ostatni')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["accessory pointer", {'selected' : _ctx.accessoriesVisible(accessories)}]),
                                        onClick: ($event: any) => (_ctx.triggerAccessory(null, accessories))
                                      }, [
                                        _createTextVNode(" Bez příslušenství "),
                                        (_ctx.accessoriesVisible(accessories))
                                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                              key: 0,
                                              style: {"height":"23px"},
                                              class: "icon",
                                              icon: ['fas', 'check']
                                            }))
                                          : _createCommentVNode("", true)
                                      ], 10, _hoisted_45))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessories.values, (accessory) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["accessory pointer", {'selected' : _ctx.accessoryVisible(accessory)}]),
                                      key: accessory.id,
                                      onClick: ($event: any) => (_ctx.triggerAccessory(accessory, accessories))
                                    }, [
                                      _createTextVNode(_toDisplayString(accessory.text) + " ", 1),
                                      (_ctx.accessoryVisible(accessory))
                                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                            key: 0,
                                            style: {"height":"23px"},
                                            class: "icon",
                                            icon: ['fas', 'check']
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_46))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("canvas", _hoisted_49, null, 512),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              class: "configurator-text pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeRotation()))
            }, [
              (_ctx.rotate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pause'] }),
                    _createTextVNode(" Zastavit rotaci")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_52, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'play'] }),
                    _createTextVNode(" Spustit rotaci")
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}